
import GSpacer from '../g-spacer';
import GContainer from '../g-container';
import { getPostDate, getPostReadingTime } from '~/utils/blog';
import '~/plugins/filters';

export default {
  name: 'g-blog-detail-header',
  components: {
    GSpacer,
    GContainer,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    date() {
      return getPostDate(this.post);
    },
    readingTime() {
      return getPostReadingTime(this.post.content.content);
    },
  },
};
